import {Box, Skeleton} from '@mui/material';

const skeletonSx = {
  width: '100%',
  mb: 2
};
export default function SkeletonSidebar() {
  return (
    <Box>
      <Skeleton variant="rectangular" animation={false} height={50} sx={skeletonSx} />
      <Skeleton variant="rectangular" animation={false} height={100} sx={skeletonSx} />
      <Skeleton variant="rectangular" animation={false} height={30} />
      <Skeleton variant="rectangular" animation={false} height={30} />
      <Skeleton variant="rectangular" animation={false} height={30} />
      <Skeleton variant="rectangular" animation={false} height={30} />
      <Skeleton variant="rectangular" animation={false} height={30} />
    </Box>
  );
}
